import * as React from 'react';
import classNames from 'classnames';
import ExternalLink from 'core/components/ExternalLink';
import { useIntl } from 'react-intl';
import useIsMobile from 'core/hooks/useIsMobile';
import * as styles from './WellnessWednesday.module.scss';
import Icon from './assets/bond-wellness.inline.svg';

interface WellnessWednesdayProps {
    className?: string;
    daysOfWeek?: ReadonlyArray<string>;
    copy: string;
    link: string;
    hasMobileLink?: boolean;
}

export default function WellnessWednesday({
    className,
    daysOfWeek,
    copy,
    link,
    hasMobileLink,
}: WellnessWednesdayProps) {
    const intl = useIntl();
    const isMobile = useIsMobile();

    const daysOfWeekString = React.useMemo(() => {
        if (!daysOfWeek || daysOfWeek.length === 0) {
            return 'Wednesday';
        }

        if (daysOfWeek.length === 1) {
            return daysOfWeek[0];
        }

        const result = daysOfWeek?.join(', ') ?? 'Wednesday';
        const lastCommaIndex = result.lastIndexOf(',');
        if (lastCommaIndex !== -1) {
            return `${result.substring(
                0,
                lastCommaIndex,
            )} or${result.substring(lastCommaIndex + 1)}`;
        }
        return result;
    }, [daysOfWeek]);

    const linkComponent = React.useMemo(() => {
        if (hasMobileLink || !isMobile) {
            return <ExternalLink href={link}>{copy}</ExternalLink>;
        }
        return <strong>{copy}</strong>;
    }, [copy, hasMobileLink, isMobile, link]);

    return (
        <div className={classNames(className, styles.root)}>
            <Icon className={styles.icon} />
            <p>
                {intl.formatMessage(
                    { id: 'booking.form.date.wellnessWednesday' },
                    {
                        link: linkComponent,
                        wbr: <wbr />,
                        daysOfWeek: daysOfWeekString,
                    },
                )}
            </p>
        </div>
    );
}
